<template>
  <div class="app-header">
    <div class="app-wapper">
      <div class="app-logo">
        <img src="~assets/images/app-logo.png" alt="logo" />
      </div>
      <div class="app-userinfo">
        <span class="logout" @click="handleLoginOut">{{
          $t("lang.headerPage1")
        }}</span>
        <span class="line" v-if="name"></span>
        <router-link to="/me" v-if="name" tag="span" class="username">{{
          name
        }}</router-link>
        <span class="changeLanguage" @click="changeLanguage">{{
          language === "cn" ? "英文" : "CN"
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["name", "language"])
  },
  methods: {
    changeLanguage() {
      let lang = this.$i18n.locale === "cn" ? "en" : "cn";
      this.$i18n.locale = lang;
      this.$store
        .dispatch("setLanguage", lang)
        .then(() => {
          localStorage.setItem("language", lang);
        })
        .catch(() => {});
    },
    handleLoginOut() {
      this.$store
        .dispatch("FedLogOut")
        .then(() => {
          this.$router.push({ path: "/login" });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.app-header {
  width: 100%;
  height: 68px;
  line-height: 68px;
  background-color: #fff;
  .app-logo {
    width: 126px;
    height: 45px;
    margin: 12px 0;
    float: left;
    img {
      display: block;
      width: 100%;
      line-height: 0;
      border: 0;
    }
  }
  .app-userinfo {
    span {
      display: inline-block;
      float: right;
    }
    .changeLanguage {
      color: #ffa438;
      cursor: pointer;
      margin-right: 20px;
    }
    .line {
      height: 18px;
      margin: 25px 15px;
      width: 1px;
      background-color: #333;
    }
    .logout {
      color: #ff6868;
      cursor: pointer;
    }
    .username {
      color: #ffa438;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-header/app-header.vue